import styles from '@/styles/input-field.module.css';
import { ReactElement } from 'react';

export interface SelectFieldProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string | ReactElement;
  error?: boolean;
  errorMessage?: string;
}

export default function SelectField({
  label,
  error = false,
  errorMessage = ``,
  className,
  children,
  ...restProps
}: SelectFieldProps) {
  const errorId = restProps.id ? `${restProps.id}-error` : undefined;
  const describedBy = [restProps[`aria-describedby`], error && errorId].filter(Boolean).join(` `) || undefined;

  return (
    <div className={`${styles.container} ${className ? className : ``}`}>
      <>
        {label && (typeof label === `string` ? <label htmlFor={restProps.id}>{label}</label> : label)}
        <select
          className={`${styles.input} ${error ? styles.error : ``}`}
          {...restProps}
          aria-describedby={describedBy}
          aria-invalid={error || undefined}
        >
          {children}
        </select>
        {error && (
          <span className={styles.error_message} id={errorId} role="alert">
            {errorMessage}
          </span>
        )}
      </>
    </div>
  );
}
